<script>
import store from '@state/store'
import values from 'lodash/values'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import CompanyDetail from '@adminCompanies/components/detail.vue'
import CompanySettings from '@adminCompanies/components/settings.vue'
import Table from '@adminCompanies/components/table.vue'
import AddMembers from '@adminCompanies/components/add-members.vue'
import AddEventAdmins from '@adminCompanies/components/add-event-admins.vue'

export default {
  components: {
    Layout,
    Tab,
    Tabs,
    CompanyDetail,
    CompanySettings,
    Table,
    AddMembers,
    AddEventAdmins,
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    companyId() {
      return +this.$route.params.companyId
    },
    isEditForm() {
      return !!this.companyId
    },
    companiesList() {
      return this.$store.state.adminCompanies.lists || []
    },
    companyItem() {
      if (this.isEditForm) {
        if (this.companiesList.length) {
          return this.companiesList.find((item) => item.id === this.companyId)
        }
        return this.currentUser.companies.find(
          (item) => item.id === this.companyId
        )
      }
      return {}
    },
  },
  methods: {
    refreshMembersTable() {
      this.$refs.membersTable.fetchData()
    },
    refreshAdminsTable() {
      this.$refs.adminsTable.fetchData()
    },
    refreshEventAdminsTable() {
      this.$refs.eventAdminsTable.fetchData()
    },
    triggerDetailTab() {
      this.$refs.tabsWrap.selectTab(0)
    },
    saveEvent(params) {
      const refsValues = values(this.$refs)
      let data = {}

      refsValues.map((component) => {
        if (component.getFormData) {
          const formData = component.getFormData()
          data = Object.assign(data, formData)
        }
      })

      if (!data.name) {
        return
      }
      if (this.isEditForm) {
        data = Object.assign({}, this.companyItem, data)
        store
          .dispatch('adminCompanies/updateItem', data)
          .then(() => alert('company was succesfully updated!'))
      } else {
        data = Object.assign({}, data, { csv: false })
        store
          .dispatch('adminCompanies/newItem', data)
          .then(() => alert('company was succesfully created!'))
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white px-7.5 pt-4 text-xl">
      <span class="">Hubs</span>
      <span class="breadcrumb-separator">></span>
      <span class="text-blue">{{ isEditForm ? 'Edit' : 'New' }} Hub</span>
    </div>

    <div>
      <Tabs
        ref="tabsWrap"
        :classes="'bg-white flex justify-around border-none'"
        :parent-classes="'bg-white flex justify-center'"
        :tab-classes="
          'border-b-5 pb-5 text-xl mr-16 leading-loose cursor-pointer'
        "
      >
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 24.861 25.805" class="inline-block align-middle mr-1"><path id="Path_129" data-name="Path 129" d="M38.27,10.678l-12.545.031V7.5H13.41V33.305H14.5V20.224H24.636v2.925H38.271l-3.842-6.236ZM24.636,19.135H14.5V8.589H24.636ZM36.3,22.059H25.725V11.8H36.306l-3.172,5.117Z" transform="translate(-13.41 -7.5)" fill="currentColor" /></svg> <span class="align-middle">Details</span>'
        >
          <div :class="$style.tabContent" class="pt-14 flex justify-center">
            <CompanyDetail
              ref="companyDetail"
              :item-name="companyItem ? companyItem.name : ''"
              :item-image="companyItem ? companyItem.image_url : ''"
              @trigger-detail-tab="triggerDetailTab"
            />
          </div>
        </Tab>
        <Tab
          v-if="isEditForm"
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21.044 24.049" class="inline-block align-middle mr-1"><g id="Group_244" data-name="Group 244" transform="translate(-453.062 -37.45)"><path id="Path_109" data-name="Path 109" d="M463.593,50.506a6.528,6.528,0,1,0-6.529-6.528A6.546,6.546,0,0,0,463.593,50.506Zm-5.133-6.528a5.139,5.139,0,0,1,5.133-5.133l.133,0a5.135,5.135,0,1,1-5.266,5.135Z" fill="currentColor"/><path id="Path_110" data-name="Path 110" d="M463.584,50.727a10.534,10.534,0,0,0-10.522,10.522v.25h1.4v-.25a9.139,9.139,0,0,1,9.123-9.123h0a9.126,9.126,0,0,1,9.127,9.123v.25h1.15v-.25h.24A10.534,10.534,0,0,0,463.584,50.727Z" fill="currentColor"/></g></svg> <span class="align-middle">Hub Members</span>'
        >
          <div :class="$style.tabContent" class="pt-4">
            <Table
              ref="membersTable"
              :company-id="companyId"
              :no-new-btn="true"
              :no-edit-btn="true"
              table-type="USERS"
            />
            <AddMembers
              :company-id="companyId"
              @refresh-members-table="refreshMembersTable"
            />
          </div>
        </Tab>
        <Tab
          v-if="isEditForm"
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21.044 24.049" class="inline-block align-middle mr-1"><g id="Group_244" data-name="Group 244" transform="translate(-453.062 -37.45)"><path id="Path_109" data-name="Path 109" d="M463.593,50.506a6.528,6.528,0,1,0-6.529-6.528A6.546,6.546,0,0,0,463.593,50.506Zm-5.133-6.528a5.139,5.139,0,0,1,5.133-5.133l.133,0a5.135,5.135,0,1,1-5.266,5.135Z" fill="currentColor"/><path id="Path_110" data-name="Path 110" d="M463.584,50.727a10.534,10.534,0,0,0-10.522,10.522v.25h1.4v-.25a9.139,9.139,0,0,1,9.123-9.123h0a9.126,9.126,0,0,1,9.127,9.123v.25h1.15v-.25h.24A10.534,10.534,0,0,0,463.584,50.727Z" fill="currentColor"/></g></svg> <span class="align-middle">Event Admins</span>'
        >
          <div :class="$style.tabContent" class="pt-4">
            <Table
              ref="eventAdminsTable"
              :company-id="companyId"
              :no-new-btn="true"
              :no-edit-btn="true"
              table-type="EVENT_ADMINS"
            />
            <AddEventAdmins
              :company-id="companyId"
              @refresh-event-admins-table="refreshEventAdminsTable"
            />
          </div>
        </Tab>
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000.23" fill="currentColor" height="24" width="24" class="inline-block align-middle mr-1"><title>Kyndhub edit icon</title><path d="M499.86,315.82c101.73,0,184.22,82.43,184.25,184.16v.09c0,101.73-82.43,184.22-184.16,184.25h-.09a184.25,184.25,0,0,1,0-368.5Zm0,52.65A131.58,131.58,0,1,0,631.55,500h0A131.6,131.6,0,0,0,500,368.42h-.09ZM805.4,693.93a26.29,26.29,0,0,1-4.62-31.2,338.44,338.44,0,0,0,26.76-65A26.32,26.32,0,0,1,852.73,579h94.44V421.12h-94.3a26.29,26.29,0,0,1-25.19-18.77,338.7,338.7,0,0,0-26.76-65,26.29,26.29,0,0,1,4.62-31.2l66.65-66.7L760.56,127.83l-66.79,66.79a26.31,26.31,0,0,1-31.16,4.63,341.46,341.46,0,0,0-65-26.81,26.35,26.35,0,0,1-18.76-25.24V52.81H420.91V147.2a26.35,26.35,0,0,1-18.77,25.24,342,342,0,0,0-65,26.81A26.3,26.3,0,0,1,306,194.62L239.35,128,127.67,239.46l66.65,66.65A26.33,26.33,0,0,1,199,337.32a337.57,337.57,0,0,0-26.77,65A26.3,26.3,0,0,1,147,421.07H52.46V579H146.9a26.32,26.32,0,0,1,25.19,18.77,338.44,338.44,0,0,0,26.76,65,26.29,26.29,0,0,1-4.62,31.2l-66.65,66.66L239.21,872.22l66.65-66.66A26.31,26.31,0,0,1,337,800.94,338,338,0,0,0,402,827.7a26.35,26.35,0,0,1,18.86,25.24v94.43h158V852.94a26.35,26.35,0,0,1,18.86-25.24,338,338,0,0,0,64.94-26.76,26.31,26.31,0,0,1,31.16,4.62l66.65,66.66L872.19,760.58Zm50.84-23.71L928,742a26.3,26.3,0,0,1,0,37.2h0L779.14,928.05a26.34,26.34,0,0,1-37.21,0l-71.78-71.78a392.43,392.43,0,0,1-38.6,15.85V973.81a26.35,26.35,0,0,1-26.3,26.31H394.61a26.35,26.35,0,0,1-26.3-26.31V872.12a392.43,392.43,0,0,1-38.6-15.85l-71.78,71.78a26.34,26.34,0,0,1-37.21,0L71.88,779.21a26.3,26.3,0,0,1,0-37.19l0,0,71.74-71.78a392.5,392.5,0,0,1-15.86-38.6H26.3A26.3,26.3,0,0,1,0,605.32H0V394.77a26.36,26.36,0,0,1,26.3-26.3H128a392.5,392.5,0,0,1,15.86-38.6L72.11,258.09a26.31,26.31,0,0,1,0-37.2h0L221,72a26.36,26.36,0,0,1,37.21,0l71.55,71.79a395.25,395.25,0,0,1,38.6-15.9V26.19A26.35,26.35,0,0,1,394.61-.12H605.16a26.36,26.36,0,0,1,26.3,26.31V127.88a395.25,395.25,0,0,1,38.6,15.9L741.84,72a26.36,26.36,0,0,1,37.21,0L927.89,220.88a26.3,26.3,0,0,1,0,37.19l0,0-71.74,71.78A392.5,392.5,0,0,1,872,368.47H973.7a26.36,26.36,0,0,1,26.3,26.3V605.32a26.3,26.3,0,0,1-26.3,26.3H872.19a390.36,390.36,0,0,1-16,38.6Z" transform="translate(0 0.12)" /></svg> <span class="align-middle">Settings</span>'
        >
          <div :class="$style.tabContent" class="pt-14">
            <div class="flex justify-center">
              <CompanySettings
                ref="companySettings"
                :item-open="companyItem ? companyItem.open : null"
                :company-id="companyId"
                :is-edit-form="isEditForm"
                @refresh-admins-table="refreshAdminsTable"
              />
            </div>
            <div v-if="isEditForm" class="mt-10">
              <Table
                ref="adminsTable"
                :no-new-btn="true"
                :no-edit-btn="true"
                :company-id="companyId"
                table-type="ADMIN_USERS"
              />
            </div>
          </div>
        </Tab>
        <Tab
          v-if="isEditForm"
          title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 896.11 1000" width="25" height="25" fill="currentColor" class="inline-block align-middle mr-1"><title>Kyndhub_Groups_Icon</title><path d="M857.9,580l-5.49-1.27V421.27l5.53-1.23a114.68,114.68,0,0,0,90.11-112.48,116.12,116.12,0,0,0-201.2-79.43l-3.85,4.1L609.58,155.14l1.31-5.2a145.3,145.3,0,0,0,5.41-33.39,116.5,116.5,0,0,0-233-.11v.11a89.39,89.39,0,0,0,5.16,32.77l2.09,5.61-133.5,77.34-3.85-4.1A116,116,0,1,0,142,420l5.49,1.27V578.69L142,580A116,116,0,1,0,253.21,771.83l3.85-4.1,133.09,77.13-1.31,5.2a145.3,145.3,0,0,0-5.41,33.39,116.5,116.5,0,0,0,233,.11v-.11a89.39,89.39,0,0,0-5.16-32.77l-2.09-5.61,133.66-77.46,3.85,4.09A116,116,0,1,0,857.9,579.84ZM832.83,231.78a74.59,74.59,0,0,1,74.51,74.51v.16a75.59,75.59,0,0,1-74.51,74.23,74.51,74.51,0,0,1,0-149ZM501.36,43.43a74.51,74.51,0,0,1,0,149,73.72,73.72,0,0,1-74.51-72.94c0-.52,0-1,0-1.57A74.59,74.59,0,0,1,501.36,43.43ZM96.77,307.56a74.51,74.51,0,1,1,74.51,74.55H171A75.58,75.58,0,0,1,96.77,307.56Zm73.12,459.35a74.51,74.51,0,1,1,74.51-74.59,74.51,74.51,0,0,1-74.51,74.59h0ZM501.36,956.53a74.52,74.52,0,0,1,0-149,73.73,73.73,0,0,1,74.51,73c0,.52,0,1,0,1.57a74.6,74.6,0,0,1-74.51,74.55Zm215-264.21a82.16,82.16,0,0,0,5,30.93l2.5,5.77-134,77.71-3.85-4.1a115.31,115.31,0,0,0-162.94-6.52q-3.39,3.14-6.52,6.52l-3.85,4.1L279.67,729.59l1.31-5.16a134.55,134.55,0,0,0,5.41-32A116.61,116.61,0,0,0,196.27,580l-5.49-1.27V421.31l5.49-1.27a116.61,116.61,0,0,0,90.12-112.48,82.13,82.13,0,0,0-5-30.93l-2.5-5.77L413,193.27l3.85,4.1a115.31,115.31,0,0,0,162.94,6.52q3.39-3.13,6.52-6.52l3.86-4.1L723,270.41l-1.31,5.16a134.55,134.55,0,0,0-5.41,32A116.61,116.61,0,0,0,806.41,420l5.49,1.27V578.69L806.41,580A116.62,116.62,0,0,0,716.33,692.32Zm115.1,74.51a74.51,74.51,0,1,1,0-149h.25A75.57,75.57,0,0,1,906,692.32,74.6,74.6,0,0,1,831.43,767Z" transform="translate(-51.94 0)"/></svg> <span class="align-middle">Groups</span>'
        >
          <div :class="$style.tabContent" class="pt-4">
            <Table :company-id="companyId" table-type="GROUPS" />
          </div>
        </Tab>
      </Tabs>

      <div
        class="bg-white py-20 px-8 mx-7.5 rounded-xl rounded-t-none shadow-lg"
      >
        <div class="flex justify-center">
          <button
            class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5"
            @click="saveEvent"
          >
            Save
          </button>
          <button
            class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5 ml-2"
          >
            <router-link :to="{ name: 'adminCompanies' }">
              Return
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.tabContent {
  @apply bg-white mt-8 mx-7.5 px-8 rounded-xl rounded-b-none shadow-lg;
}
</style>
